import Lottie from 'components/Lottie';
import {CDN_IMAGE_URL} from 'configs';
import React from 'react';
import {Fade} from 'reactstrap';
import urlJoin from 'url-join';

function HelpSectionAnimation({url}) {
  return (
    <Fade style={{height: '435px', width: '556px'}}>
      <Lottie
        url={urlJoin(CDN_IMAGE_URL, url)}
        style={{height: '435px', width: '556px'}}
      />
    </Fade>
  );
}

export default HelpSectionAnimation;
